"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CachedReadableLiquity = void 0;
/** @internal */
class _CachedReadableLiquity {
    constructor(readable, cache) {
        this._readable = readable;
        this._cache = cache;
    }
    async getTotalRedistributed(...extraParams) {
        var _b;
        return ((_b = this._cache.getTotalRedistributed(...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getTotalRedistributed(...extraParams));
    }
    async getTroveBeforeRedistribution(address, ...extraParams) {
        var _b;
        return ((_b = this._cache.getTroveBeforeRedistribution(address, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getTroveBeforeRedistribution(address, ...extraParams));
    }
    async getTrove(address, ...extraParams) {
        const [troveBeforeRedistribution, totalRedistributed] = await Promise.all([
            this.getTroveBeforeRedistribution(address, ...extraParams),
            this.getTotalRedistributed(...extraParams)
        ]);
        return troveBeforeRedistribution.applyRedistribution(totalRedistributed);
    }
    async getNumberOfTroves(...extraParams) {
        var _b;
        return ((_b = this._cache.getNumberOfTroves(...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getNumberOfTroves(...extraParams));
    }
    async getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams) {
        var _b;
        return ((_b = this._cache.getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams));
    }
    async getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams) {
        var _b;
        return ((_b = this._cache.getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams));
    }
    async getCollPrice(address, ...extraParams) {
        var _b;
        return ((_b = this._cache.getCollPrice(address, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getCollPrice(address, ...extraParams));
    }
    async getPrices(addresses, ...extraParams) {
        var _b;
        return ((_b = this._cache.getPrices(addresses, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getPrices(addresses, ...extraParams));
    }
    async getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams) {
        var _b;
        return ((_b = this._cache.getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams));
    }
    async getUnderlyingDecimals(vaultTokens, ...extraParams) {
        var _b;
        return ((_b = this._cache.getUnderlyingDecimals(vaultTokens, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getUnderlyingDecimals(vaultTokens, ...extraParams));
    }
    async getUnderlyingTokens(vaultTokens, ...extraParams) {
        var _b;
        return ((_b = this._cache.getUnderlyingTokens(vaultTokens, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getUnderlyingTokens(vaultTokens, ...extraParams));
    }
    async getBalances(addresses, ...extraParams) {
        var _b;
        // let _a;
        // return (_a = this._cache.getBalances(addresses, ...extraParams)) !== null && _a !== void 0
        //   ? _a
        //   : this._readable.getBalances(addresses, ...extraParams);
        return ((_b = this._cache.getBalances(addresses, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getBalances(addresses, ...extraParams));
    }
    async getLPBalances(addresses, ...extraParams) {
        var _b;
        return ((_b = this._cache.getLPBalances(addresses, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getLPBalances(addresses, ...extraParams));
    }
    async getFarm(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getFarm(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getFarm(address, ...extraParams);
    }
    async getBoostedFarm(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getBoostedFarm(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getBoostedFarm(address, ...extraParams);
    }
    async getVEPREONStake(address, ...extraParams) {
        let _a;
        // console.log(address);
        return (_a = this._cache.getVEPREONStake(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getVEPREONStake(address, ...extraParams);
    }
    async getPoolRewardRate(...extraParams) {
        let _a;
        return (_a = this._cache.getPoolRewardRate(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getPoolRewardRate(...extraParams);
    }
    async getRemainingStabilityPoolPREONReward(...extraParams) {
        let _a;
        return (_a = this._cache.getRemainingStabilityPoolPREONReward(...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getRemainingStabilityPoolPREONReward(...extraParams);
    }
    async getDepositFee(VCInput, VCOutput, ...extraParams) {
        let _a;
        return (_a = this._cache.getDepositFee(VCInput, VCOutput, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getDepositFee(VCInput, VCOutput, ...extraParams);
    }
    async getEstimatedFarmRewards(amount, time, ...extraParams) {
        let _a;
        return (_a = this._cache.getEstimatedFarmRewards(amount, time, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getEstimatedFarmRewards(amount, time, ...extraParams);
    }
    async getEstimatedVePreonRewards(amount, time, ...extraParams) {
        let _a;
        return (_a = this._cache.getEstimatedVePreonRewards(amount, time, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getEstimatedVePreonRewards(amount, time, ...extraParams);
    }
    async getEstimatedPREONPoolRewards(amount, time, ...extraParams) {
        let _a;
        return (_a = this._cache.getEstimatedPREONPoolRewards(amount, time, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getEstimatedPREONPoolRewards(amount, time, ...extraParams);
    }
    // async getRiskiestTrove(...extraParams: T): Promise<TroveWithPendingRedistribution> {
    //   return (
    //     this._cache.getRiskiestTrove(...extraParams) ??
    //     this._readable.getRiskiestTrove(...extraParams)
    //   )
    // }
    async getBalanceERC20(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getBalanceERC20(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getBalanceERC20(address, ...extraParams);
    }
    async getLP(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getLP(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getLP(address, ...extraParams);
    }
    async getPREONBalance(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getPREONBalance(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getPREONBalance(address, ...extraParams);
    }
    async hasClaimableCollateral(address, ...extraParams) {
        let _a;
        return (_a = this._cache.hasClaimableCollateral(address, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.hasClaimableCollateral(address, ...extraParams);
    }
    async getRedemptionBonus(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getRedemptionBonus(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getRedemptionBonus(address, ...extraParams);
    }
    async getRedemptionFeeRate(...extraParams) {
        let _a;
        return (_a = this._cache.getRedemptionFeeRate(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getRedemptionFeeRate(...extraParams);
    }
    async getReceiptPerUnderlying(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getReceiptPerUnderlying(address, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getReceiptPerUnderlying(address, ...extraParams);
    }
    async getUnderlyingPerReceipt(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getUnderlyingPerReceipt(address, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getUnderlyingPerReceipt(address, ...extraParams);
    }
    async getUnderlyingDecimal(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getUnderlyingDecimal(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getUnderlyingDecimal(address, ...extraParams);
    }
    async getUnderlyingToken(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getUnderlyingToken(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getUnderlyingToken(address, ...extraParams);
    }
    async getSortedTroveHead(...extraParams) {
        let _a;
        return (_a = this._cache.getSortedTroveHead(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSortedTroveHead(...extraParams);
    }
    async getSortedTroveTail(...extraParams) {
        let _a;
        return (_a = this._cache.getSortedTroveTail(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSortedTroveTail(...extraParams);
    }
    async getSortedTroveSize(...extraParams) {
        let _a;
        return (_a = this._cache.getSortedTroveSize(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSortedTroveSize(...extraParams);
    }
    async getSortedTroveNext(id, ...extraParams) {
        let _a;
        return (_a = this._cache.getSortedTroveNext(id, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSortedTroveNext(id, ...extraParams);
    }
    async getSortedTrovePrev(id, ...extraParams) {
        let _a;
        return (_a = this._cache.getSortedTrovePrev(id, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSortedTrovePrev(id, ...extraParams);
    }
    async getCurrentAICR(borrower, ...extraParams) {
        let _a;
        return (_a = this._cache.getCurrentAICR(borrower, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getCurrentAICR(borrower, ...extraParams);
    }
    async getTroveDebt(borrower, ...extraParams) {
        let _a;
        return (_a = this._cache.getTroveDebt(borrower, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getTroveDebt(borrower, ...extraParams);
    }
    async getAllowanceOf(owner, token, spender, amount, ...extraParams) {
        let _a;
        return (_a = this._cache.getAllowanceOf(owner, token, spender, amount, ...extraParams)) !==
            null && _a !== void 0
            ? _a
            : this._readable.getAllowanceOf(owner, token, spender, amount, ...extraParams);
    }
    async getStarAllowance(from, to, amount, ...extraParams) {
        let _a;
        return (_a = this._cache.getStarAllowance(from, to, amount, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getStarAllowance(from, to, amount, ...extraParams);
    }
    async getPREONPrice(...extraParams) {
        let _a;
        return (_a = this._cache.getPREONPrice(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getPREONPrice(...extraParams);
    }
    async getSTARPrice(...extraParams) {
        let _a;
        return (_a = this._cache.getSTARPrice(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSTARPrice(...extraParams);
    }
    async getGlobalBoostFactor(...extraParams) {
        let _a;
        return (_a = this._cache.getGlobalBoostFactor(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getGlobalBoostFactor(...extraParams);
    }
    async getDecayedBoost(address, ...extraParams) {
        let _a;
        return (_a = this._cache.getDecayedBoost(address, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getDecayedBoost(address, ...extraParams);
    }
    async getCollateralSurplusBalancee(...extraParams) {
        let _a;
        return (_a = this._cache.getCollateralSurplusBalancee(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getCollateralSurplusBalancee(...extraParams);
    }
    async getVaultTokens(whitelistedCollaterals, ...extraParams) {
        let _a;
        return (_a = this._cache.getVaultTokens(whitelistedCollaterals, ...extraParams)) !== null &&
            _a !== void 0
            ? _a
            : this._readable.getVaultTokens(whitelistedCollaterals, ...extraParams);
    }
    async getWhitelistedCollaterals(...extraParams) {
        let _a;
        return (_a = this._cache.getWhitelistedCollaterals(...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getWhitelistedCollaterals(...extraParams);
    }
    async getICR(userAddress, ...extraParams) {
        let _a;
        return (_a = this._cache.getICR(userAddress, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getICR(userAddress, ...extraParams);
    }
    async getVcValue(userAddress, ...extraParams) {
        let _a;
        return (_a = this._cache.getVcValue(userAddress, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getVcValue(userAddress, ...extraParams);
    }
    async getSafetyRatios(addresses, ...extraParams) {
        let _a;
        return (_a = this._cache.getSafetyRatios(addresses, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getSafetyRatios(addresses, ...extraParams);
    }
    async getRecoveryRatios(addresses, ...extraParams) {
        let _a;
        return (_a = this._cache.getRecoveryRatios(addresses, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getRecoveryRatios(addresses, ...extraParams);
    }
    async getDecimals(addresses, ...extraParams) {
        let _a;
        return (_a = this._cache.getDecimals(addresses, ...extraParams)) !== null && _a !== void 0
            ? _a
            : this._readable.getDecimals(addresses, ...extraParams);
    }
    async getTotal(...extraParams) {
        var _b;
        return (_b = this._cache.getTotal(...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getTotal(...extraParams);
    }
    async getStabilityDeposit(address, ...extraParams) {
        var _b;
        return ((_b = this._cache.getStabilityDeposit(address, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getStabilityDeposit(address, ...extraParams));
    }
    async getSTARInStabilityPool(...extraParams) {
        var _b;
        return ((_b = this._cache.getSTARInStabilityPool(...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getSTARInStabilityPool(...extraParams));
    }
    async getSTARBalance(address, ...extraParams) {
        var _b;
        return ((_b = this._cache.getSTARBalance(address, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getSTARBalance(address, ...extraParams));
    }
    async getTroves(params, ...extraParams) {
        var _b;
        const { beforeRedistribution, ...restOfParams } = params;
        const [totalRedistributed, troves] = await Promise.all([
            beforeRedistribution ? undefined : this.getTotalRedistributed(...extraParams),
            (_b = this._cache.getTroves({ beforeRedistribution: true, ...restOfParams }, ...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getTroves({ beforeRedistribution: true, ...restOfParams }, ...extraParams)
        ]);
        if (totalRedistributed) {
            return troves.map(trove => trove.applyRedistribution(totalRedistributed));
        }
        else {
            return troves;
        }
    }
    async getFees(...extraParams) {
        var _b;
        return (_b = this._cache.getFees(...extraParams)) !== null && _b !== void 0 ? _b : this._readable.getFees(...extraParams);
    }
}
exports._CachedReadableLiquity = _CachedReadableLiquity;
//# sourceMappingURL=_CachedReadableLiquity.js.map